import { List as IList } from 'immutable';

export const selectNewNotificationsCount = (state) => state.notificationReducer.get('newNotificationsCount', 0);
export const selectNotifications = (state) => state.notificationReducer.get('notifications', IList());
